import {Component} from "react"
import PropTypes from "prop-types"
import {withRouter} from "react-router-dom"

import MenuItem from "../MenuItem/MenuItem.jsx"

import './Sidebar.scss'

class Sidebar extends Component {

  static propTypes = {
    items: PropTypes.object.isRequired,
    isCurrentRoute: PropTypes.func.isRequired
  }

  render() {
    const {items} = this.props
    return (<div id={'sidebar-menu'} className="sidebar">
      <div className="sidebar-inner">
        {Object.keys(items).map((itemKey, index) => {
          const item = items[itemKey]
          return <MenuItem
            key={`sidebar-menu-item-${index}`}
            linkRoute={item.route}
            isCurrentRoute={this.props.isCurrentRoute(item.isCurrentRouteKey)}
            alt={item.alt}
            activeIcon={item.activeIcon}
            icon={item.icon}
            tooltip={(item.tooltip)? item.tooltip : item.label}
            menuType={item.type}
            onClick={item.onClick}
          />
        } )}
      </div>
    </div>)
  }
}

export default withRouter(Sidebar)